/**
 * Exportación centralizada de todos los endpoints
 */
import * as branches from "./endpoints/branches";
import * as recipes from "./endpoints/recipes";
import * as products from "./endpoints/products";

const api = {
  branches,
  recipes,
  products,
};

export default api;

